import { createFileRoute } from "@tanstack/react-router";
import { ConnectionsCreateRouteContent } from "../create";
import { pruneSearch } from "@/lib/router-search";

export const Route = createFileRoute("/$owner/connectors/create/")({
	validateSearch: (search: Record<string, unknown>) =>
		pruneSearch({
			connector:
				typeof search.connector === "string" && search.connector.length > 0
					? search.connector
					: undefined,
			install:
				typeof search.install === "string" && search.install.length > 0
					? search.install
					: undefined,
		}),
	component: ConnectionsCreateIndexPage,
});

function ConnectionsCreateIndexPage() {
	const { owner } = Route.useParams();
	const { connector, install } = Route.useSearch();
	return (
		<ConnectionsCreateRouteContent
			owner={owner}
			initialConnectorKey={connector || install}
		/>
	);
}
